import type { LicenseTier } from "../schemas";
import type { LicensedProductCategoryName } from "../types";

import { useUser } from "./use-user";

export const useLicensedValue = <T>(
	value: T,
	productCategory: LicensedProductCategoryName,
	tier: LicenseTier,
	licenseFeatureFlag?: string | string[],
	bypassForPacksizeUser?: boolean,
	fallback: T | null = null,
	bypassForPacksizePartner?: boolean,
): T | null => {
	const { hasLicense, isPacksizeUser, isPacksizePartner } = useUser();

	if (bypassForPacksizeUser === true && isPacksizeUser === true) {
		return value;
	}

	if (bypassForPacksizePartner === true && isPacksizePartner === true) {
		return value;
	}

	const licenseResult = hasLicense(productCategory, tier, licenseFeatureFlag);

	if (licenseResult === undefined) {
		return null;
	}

	if (licenseResult === false) {
		return fallback;
	}

	return value;
};
